/**
 * Determines whether or not the x,y coordinates are withing the box
 * @param x - The horizontal coordinate within the viewport (clientX)
 * @param y - The vertical coordinate within the viewport (clientY)
 * @param box - The bounding rectangle in page coordinates
 */
export function isInsideBoundingBox(x: number, y: number, box: DOMRect): boolean {
    x -= window.pageXOffset;
    y -= window.pageYOffset;

    return x >= box.left && x < box.right && y >= box.top && y < box.bottom;
}

/**
 * Are the coordinates of the mouse event located within the element's bounds
 * @param ev - The mouseEvent with clientX and clientY parameters
 * @param element - A ref to the HTMLElement with a bounding box
 */
export function isMouseEventLocatedInElement(
    ev: React.MouseEvent<unknown>,
    element: React.RefObject<HTMLElement>
): boolean {
    const boundingBox = element.current?.getBoundingClientRect();
    return boundingBox ? isInsideBoundingBox(ev.clientX, ev.clientY, boundingBox) : false;
}
